import React,{useEffect,useState} from 'react';
import {useSelector} from 'react-redux';
import {useImmer} from 'use-immer';
import axios from 'axios';

import LeftMenu from './LeftMenu';
import StudyDetail from './sidebars/StudyDetail';
import SallStudies from './sidebars/SallStudies';
import SallSpecies from './sidebars/SallSpecies';
import SallCountries from './sidebars/SallCountries';
import SallReferences from './sidebars/SallReferences';
import Ssearch from './sidebars/Ssearch';
import Sfiltered from './sidebars/Sfiltered';
import Charts from './Charts';
import Toggle from './Toggle';

const LeftBlock = () => {
  const { sbBlock } = useSelector(s => s.sb);
  const [cStudy, setCStudy] = useState([]);
  const [init, setInit] = useImmer(1);
  const [popupFilter, setPopupFilter] = useImmer(!1);
  
  useEffect(() => {
    axios.get('/chart?t='+new Date().getTime())
    .then((r) => {
      setCStudy(r.data.studies);
      setInit(!1);
      document.getElementById('loader').innerHTML = ''
    });
  }, []);

  return (
    <section id="sidebar" className="open">
      <Toggle/>
      <LeftMenu/>
      <div id="tool-studies" className="sb-tool">
        <div className="sb-body">
          <div
            className="sb-body-inner"
            style={{
              display: sbBlock !== 'init' ? 'none' : ''
            }}
          >
            {
              cStudy.length
                ? <Charts cStudy={cStudy} />
                : <div className="lds-dual-ring2" />
            }
            <SallStudies init={init} setPopupFilter={setPopupFilter} />
          </div>

          <SallSpecies/>
          <SallCountries/>
          <SallReferences/>
          <Ssearch/>

          <Sfiltered/>
          <StudyDetail key="elementStudyDetail"/>
        </div>
      </div>
    </section>
  )
}

export default LeftBlock;
